var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useCallback, useMemo, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Disclosure } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { apiFetch, StyledButton, StyledButtonStyle, useData, } from "ee-react-components";
import { orchestratorUrl } from "./api";
import { StrategyFormDialog } from "./StrategyFormDialog";
import { StrategyRunDialog } from "./StrategyRunDialog";
var strategiesKey = function () { return "".concat(orchestratorUrl(), "/strategies"); };
var signalsKey = function () { return "".concat(orchestratorUrl(), "/signals"); };
var responsesKey = function () { return "".concat(orchestratorUrl(), "/responses"); };
var eventsKey = function () { return "".concat(orchestratorUrl(), "/events?limit=50"); };
var sitesListingKey = function () { return "".concat(process.env.NOC_SVC_URL, "/sites/listing"); };
var eventLogKey = function (id) { return "".concat(orchestratorUrl(), "/events/").concat(id, "/log"); };
export var StrategiesTab = function () {
    var _a, _b;
    var getAccessTokenSilently = useAuth0().getAccessTokenSilently;
    var _c = useData(strategiesKey()), strategies = _c.data, refreshStrategies = _c.execute;
    var responses = useData(responsesKey()).data;
    var signals = useData(signalsKey()).data;
    var _d = useData(eventsKey()), events = _d.data, refreshEvents = _d.execute;
    var sites = useData(sitesListingKey()).data;
    var responsesById = new Map((responses !== null && responses !== void 0 ? responses : []).map(function (r) { return [r.id, r]; }));
    var signalsById = new Map((signals !== null && signals !== void 0 ? signals : []).map(function (s) { return [s.id, s]; }));
    var sitesById = new Map((sites !== null && sites !== void 0 ? sites : []).map(function (s) { return [s.id, s]; }));
    var _e = useState(false), formOpen = _e[0], setFormOpen = _e[1];
    var _f = useState(null), editing = _f[0], setEditing = _f[1];
    var _g = useState(false), runOpen = _g[0], setRunOpen = _g[1];
    var _h = useState(null), running = _h[0], setRunning = _h[1];
    var _j = useState(null), error = _j[0], setError = _j[1];
    var sitesArr = useMemo(function () { return sites !== null && sites !== void 0 ? sites : []; }, [sites]);
    var onCancelEvent = useCallback(function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var getToken, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!window.confirm("Cancel event #".concat(event.id, "? All future schedules it created will be removed.")))
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    getToken = function () {
                        return getAccessTokenSilently({
                            authorizationParams: { audience: process.env.AUTH0_AUDIENCE },
                        });
                    };
                    return [4 /*yield*/, apiFetch("".concat(orchestratorUrl(), "/events/").concat(event.id, "/cancel"), {
                            method: "POST",
                            callbacks: { getToken: getToken },
                        })];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, refreshEvents()];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _a.sent();
                    setError(e_1.message);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [getAccessTokenSilently, refreshEvents]);
    var onEditStrategy = useCallback(function (s) {
        setEditing(s);
        setFormOpen(true);
    }, []);
    var onNewStrategy = useCallback(function () {
        setEditing(null);
        setFormOpen(true);
    }, []);
    var onRunStrategy = useCallback(function (s) {
        setRunning(s);
        setRunOpen(true);
    }, []);
    var onCloseRun = useCallback(function () { return setRunOpen(false); }, []);
    var onRan = useCallback(function () { return void refreshEvents(); }, [refreshEvents]);
    var onCloseForm = useCallback(function () { return setFormOpen(false); }, []);
    var onSavedForm = useCallback(function () { return void refreshStrategies(); }, [refreshStrategies]);
    return (React.createElement("div", { className: "flex flex-col gap-y-[24px]" },
        React.createElement("div", { className: "flex flex-row items-center justify-between" },
            React.createElement("h2", { className: "text-white font-N6" }, "Strategies"),
            React.createElement(StyledButton, { text: "New strategy", onClick: onNewStrategy })),
        error && React.createElement("div", { className: "text-red font-N8" }, error),
        !strategies && React.createElement("span", { className: "text-black-600 font-N8" }, "Loading\u2026"),
        strategies && strategies.length === 0 && (React.createElement("span", { className: "text-black-600 font-N8" }, "No strategies defined.")),
        strategies && strategies.length > 0 && (React.createElement("div", { className: "flex flex-col rounded-[10px] overflow-hidden border border-black-800" },
            React.createElement("div", { className: "grid grid-cols-[2fr_2fr_1fr_1fr_1fr_1fr_1fr] bg-black-900 px-[12px] py-[8px] text-black-400 font-N8 uppercase text-[10px] tracking-wide" },
                React.createElement("span", null, "Name"),
                React.createElement("span", null, "Response"),
                React.createElement("span", null, "Threshold"),
                React.createElement("span", null, "Priority"),
                React.createElement("span", null, "Severity"),
                React.createElement("span", null, "Sites"),
                React.createElement("span", null, "Enabled")),
            strategies.map(function (s) {
                var _a;
                var responseName = (_a = responsesById.get(s.responseId)) === null || _a === void 0 ? void 0 : _a.name;
                return (React.createElement(Disclosure, { key: s.id }, function (_a) {
                    var _b;
                    var open = _a.open;
                    return (React.createElement("div", null,
                        React.createElement(Disclosure.Button, { className: "w-full text-left grid grid-cols-[2fr_2fr_1fr_1fr_1fr_1fr_1fr] px-[12px] py-[10px] border-t border-black-800 hover:bg-black-900 transition-colors" },
                            React.createElement("span", { className: "text-white font-N8" }, s.name),
                            React.createElement("span", { className: "text-white font-N8" }, responseName !== null && responseName !== void 0 ? responseName : "-"),
                            React.createElement("span", { className: "text-white font-N8" }, s.threshold.toFixed(3)),
                            React.createElement("span", { className: "text-white font-N8" }, s.priority),
                            React.createElement("span", { className: "text-white font-N8" }, s.alertSeverity),
                            React.createElement("span", { className: "text-white font-N8" }, s.subscribedSiteIds.length),
                            React.createElement("span", { className: "text-white font-N8 flex items-center gap-x-[4px]" },
                                s.enabled ? "yes" : "no",
                                React.createElement(ChevronDownIcon, { className: "w-[12px] h-[12px] ml-auto text-black-600 transition-transform ".concat(open ? "" : "rotate-180") }))),
                        React.createElement(Disclosure.Panel, null,
                            React.createElement(StrategyExpansion, { strategy: s, sitesById: sitesById, sites: sitesArr, responseName: responseName, signalName: (_b = signalsById.get(s.signalId)) === null || _b === void 0 ? void 0 : _b.name, onEdit: function () { return onEditStrategy(s); }, onRun: function () { return onRunStrategy(s); }, onChanged: refreshStrategies, onError: setError }))));
                }));
            }))),
        React.createElement("h3", { className: "text-white font-N7 mt-[24px]" }, "Recent Events"),
        !events && React.createElement("span", { className: "text-black-600 font-N8" }, "Loading\u2026"),
        events && events.length === 0 && (React.createElement("span", { className: "text-black-600 font-N8" }, "No events yet.")),
        events && events.length > 0 && (React.createElement("div", { className: "flex flex-col rounded-[10px] overflow-hidden border border-black-800" },
            React.createElement("div", { className: "grid grid-cols-[1fr_2fr_2fr_1fr_1fr] bg-black-900 px-[12px] py-[8px] text-black-400 font-N8 uppercase text-[10px] tracking-wide" },
                React.createElement("span", null, "Status"),
                React.createElement("span", null, "Window"),
                React.createElement("span", null, "Strategy"),
                React.createElement("span", null, "Dispatches"),
                React.createElement("span", null, "Actions")),
            events.map(function (event) {
                var _a, _b;
                var cancellable = event.status === "PENDING" || event.status === "ACTIVE";
                var active = event.dispatches.filter(function (d) { return d.canceledAt == null; }).length;
                var canceled = event.dispatches.length - active;
                var strategyName = (_b = (_a = strategies === null || strategies === void 0 ? void 0 : strategies.find(function (s) { return s.id === event.strategyId; })) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : "-";
                return (React.createElement(Disclosure, { key: event.id }, function (_a) {
                    var open = _a.open;
                    return (React.createElement("div", null,
                        React.createElement(Disclosure.Button, { className: "w-full text-left grid grid-cols-[1fr_2fr_2fr_1fr_1fr] px-[12px] py-[10px] border-t border-black-800 hover:bg-black-900 transition-colors" },
                            React.createElement("span", { className: "font-N8 ".concat(event.status === "CANCELED"
                                    ? "text-red"
                                    : event.status === "ACTIVE"
                                        ? "text-green-400"
                                        : event.status === "PENDING"
                                            ? "text-yellow-400"
                                            : "text-black-400") }, event.status),
                            React.createElement("span", { className: "text-white font-N8" },
                                new Date(event.startTimestamp).toLocaleString(),
                                " \u2192",
                                " ",
                                new Date(event.endTimestamp).toLocaleString()),
                            React.createElement("span", { className: "text-black-300 font-N8" }, strategyName),
                            React.createElement("span", { className: "text-black-300 font-N8" }, canceled > 0
                                ? "".concat(active, " active / ").concat(canceled, " canceled")
                                : String(active)),
                            React.createElement("span", { className: "font-N8 flex items-center gap-x-[8px]" },
                                cancellable && (React.createElement("button", { onClick: function (e) {
                                        e.stopPropagation();
                                        void onCancelEvent(event);
                                    }, className: "font-N8 text-white bg-red hover:bg-red/80 px-[12px] py-[6px] rounded-[8px]" }, "Cancel")),
                                React.createElement(ChevronDownIcon, { className: "w-[12px] h-[12px] ml-auto text-black-600 transition-transform ".concat(open ? "" : "rotate-180") }))),
                        React.createElement(Disclosure.Panel, null,
                            React.createElement(EventAuditLog, { eventId: event.id }))));
                }));
            }))),
        React.createElement(StrategyFormDialog, { key: (_a = editing === null || editing === void 0 ? void 0 : editing.id) !== null && _a !== void 0 ? _a : "new", open: formOpen, existing: editing, onClose: onCloseForm, onSaved: onSavedForm }),
        React.createElement(StrategyRunDialog, { key: (_b = running === null || running === void 0 ? void 0 : running.id) !== null && _b !== void 0 ? _b : "run", open: runOpen, strategy: running, onClose: onCloseRun, onRan: onRan })));
};
// ─── Strategy expansion ──────────────────────────────────────────────────────
var StrategyExpansion = function (_a) {
    var strategy = _a.strategy, sites = _a.sites, sitesById = _a.sitesById, responseName = _a.responseName, signalName = _a.signalName, onEdit = _a.onEdit, onRun = _a.onRun, onChanged = _a.onChanged, onError = _a.onError;
    var getAccessTokenSilently = useAuth0().getAccessTokenSilently;
    var _b = useState(""), siteInput = _b[0], setSiteInput = _b[1];
    var _c = useState(false), busy = _c[0], setBusy = _c[1];
    var subscribedSet = useMemo(function () { return new Set(strategy.subscribedSiteIds); }, [strategy.subscribedSiteIds]);
    var availableSites = useMemo(function () { return sites.filter(function (s) { return !subscribedSet.has(s.id); }); }, [sites, subscribedSet]);
    var resolveSiteId = useCallback(function (raw) {
        var trimmed = raw.trim();
        if (!trimmed)
            return null;
        var idMatch = trimmed.match(/#(\d+)\)?\s*$/);
        if (idMatch)
            return parseInt(idMatch[1], 10);
        var asNumber = Number(trimmed);
        if (Number.isInteger(asNumber) && asNumber > 0)
            return asNumber;
        var byName = sites.find(function (s) { return s.name.toLowerCase() === trimmed.toLowerCase(); });
        return byName ? byName.id : null;
    }, [sites]);
    var addSite = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var siteId, getToken, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    siteId = resolveSiteId(siteInput);
                    if (siteId == null) {
                        return [2 /*return*/, onError("Pick a site from the list or enter its numeric id.")];
                    }
                    setBusy(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    getToken = function () {
                        return getAccessTokenSilently({
                            authorizationParams: { audience: process.env.AUTH0_AUDIENCE },
                        });
                    };
                    return [4 /*yield*/, apiFetch("".concat(orchestratorUrl(), "/strategies/").concat(strategy.id, "/sites/").concat(siteId), { method: "POST", callbacks: { getToken: getToken } })];
                case 2:
                    _a.sent();
                    setSiteInput("");
                    onChanged();
                    return [3 /*break*/, 5];
                case 3:
                    e_2 = _a.sent();
                    onError(e_2.message);
                    console.error(e_2);
                    return [3 /*break*/, 5];
                case 4:
                    setBusy(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [
        siteInput,
        resolveSiteId,
        onError,
        onChanged,
        getAccessTokenSilently,
        strategy.id,
    ]);
    var removeSite = useCallback(function (siteId) { return __awaiter(void 0, void 0, void 0, function () {
        var getToken, e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setBusy(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    getToken = function () {
                        return getAccessTokenSilently({
                            authorizationParams: { audience: process.env.AUTH0_AUDIENCE },
                        });
                    };
                    return [4 /*yield*/, apiFetch("".concat(orchestratorUrl(), "/strategies/").concat(strategy.id, "/sites/").concat(siteId), { method: "DELETE", callbacks: { getToken: getToken } })];
                case 2:
                    _a.sent();
                    onChanged();
                    return [3 /*break*/, 5];
                case 3:
                    e_3 = _a.sent();
                    onError(e_3.message);
                    return [3 /*break*/, 5];
                case 4:
                    setBusy(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [getAccessTokenSilently, strategy.id, onChanged, onError]);
    var datalistId = "spo-strategy-".concat(strategy.id, "-sites");
    return (React.createElement("div", { className: "border-t border-black-800 bg-black-1100 p-[16px] flex flex-col gap-y-[16px]" },
        React.createElement("div", { className: "grid grid-cols-2 gap-x-[24px] gap-y-[12px]" },
            React.createElement(Param, { label: "Description", value: strategy.description || "-" }),
            React.createElement(Param, { label: "Signal", value: signalName !== null && signalName !== void 0 ? signalName : "-" }),
            React.createElement(Param, { label: "Response", value: responseName !== null && responseName !== void 0 ? responseName : "-" }),
            React.createElement(Param, { label: "Threshold", value: strategy.threshold.toFixed(3) }),
            React.createElement(Param, { label: "Priority", value: String(strategy.priority) }),
            React.createElement(Param, { label: "Alert Severity", value: strategy.alertSeverity }),
            React.createElement(Param, { label: "Enabled", value: strategy.enabled ? "yes" : "no" }),
            React.createElement(Param, { label: "Created", value: new Date(strategy.createdAt).toLocaleString() })),
        React.createElement("div", { className: "flex flex-row gap-x-[8px] justify-between" },
            React.createElement(StyledButton, { text: "Edit", style: StyledButtonStyle.Gray, onClick: onEdit }),
            React.createElement(StyledButton, { text: "Fire Strategy", onClick: onRun, style: StyledButtonStyle.Gray })),
        React.createElement("div", { className: "flex flex-col gap-y-[8px]" },
            React.createElement("span", { className: "text-white font-N7" },
                "Subscribed Sites (",
                strategy.subscribedSiteIds.length,
                ")"),
            strategy.subscribedSiteIds.length === 0 && (React.createElement("span", { className: "text-black-600 font-N8" }, "No subscribers.")),
            React.createElement("div", { className: "flex flex-col gap-y-[4px]" }, strategy.subscribedSiteIds.map(function (siteId) {
                var site = sitesById.get(siteId);
                var label = site ? site.name : "Unknown site";
                return (React.createElement("div", { key: siteId, className: "flex flex-row items-center justify-between bg-black-1000 px-[12px] py-[6px] rounded-[6px]" },
                    React.createElement("span", { className: "text-white font-N8" }, label),
                    React.createElement(StyledButton, { text: "Remove", style: StyledButtonStyle.Gray, onClick: function () { return void removeSite(siteId); }, disabled: busy })));
            })),
            React.createElement("div", { className: "flex flex-row gap-x-[8px] items-center mt-[4px]" },
                React.createElement("input", { list: datalistId, placeholder: sites.length ? "Pick a site" : "Loading sites...", value: siteInput, onChange: function (e) { return setSiteInput(e.target.value); }, className: "flex-1 bg-black-1000 text-white font-N8 rounded-[8px] px-[12px] py-[8px] border border-black-700 focus:outline-none focus:border-purple-300" }),
                React.createElement("datalist", { id: datalistId }, availableSites.map(function (s) { return (React.createElement("option", { key: s.id, value: s.name })); })),
                React.createElement(StyledButton, { text: "Add", onClick: addSite, disabled: busy })))));
};
var Param = function (_a) {
    var label = _a.label, value = _a.value;
    return (React.createElement("div", { className: "flex flex-col gap-y-[2px]" },
        React.createElement("span", { className: "text-black-500 uppercase text-[10px] tracking-[0.08em] font-semibold" }, label),
        React.createElement("span", { className: "text-white font-N7 text-[14px]" }, value)));
};
// ─── Event audit log expansion ──────────────────────────────────────────────
var EventAuditLog = function (_a) {
    var eventId = _a.eventId;
    var log = useData(eventLogKey(eventId)).data;
    if (!log) {
        return (React.createElement("div", { className: "border-t border-black-800 bg-black-1100 p-[16px] text-black-600 font-N8" }, "Loading audit log\u2026"));
    }
    if (log.length === 0) {
        return (React.createElement("div", { className: "border-t border-black-800 bg-black-1100 p-[16px] text-black-600 font-N8" }, "No audit entries."));
    }
    return (React.createElement("div", { className: "border-t border-black-800 bg-black-1100 p-[16px] flex flex-col gap-y-[4px] font-mono text-[12px] max-h-[320px] overflow-auto" }, log.map(function (entry) { return (React.createElement("div", { key: entry.id, className: "flex flex-row gap-x-[8px] items-start" },
        React.createElement("span", { className: "text-black-600 shrink-0" }, new Date(entry.occurredAt).toLocaleTimeString()),
        React.createElement("span", { className: "font-bold text-white shrink-0" },
            "[",
            entry.action,
            "]"),
        Object.keys(entry.payload).length > 0 && (React.createElement("span", { className: "text-black-400" }, JSON.stringify(entry.payload))))); })));
};
